import { useSelector } from "react-redux";
import { OwnerIncidentMgmt, OwnerAddEditIncident } from "@/pages";
import { PermissionGuard } from "@/components";
import { actionsKeys, ROLE_OWNER } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { routes } from "../utils";

/**
 * Layout guard component that handles role checking dynamically at render time.
 */
const IncidentMgmtGuard = ({ children, action }: any) => {
  const currentRole = useSelector(
    (state: RootState) => state.currentData?.currentRole
  );

  const isOwner = currentRole === ROLE_OWNER;

  // Owners bypass permission checks entirely
  if (isOwner) {
    return children;
  }

  // Non-owners pass through PermissionGuard
  return (
    <PermissionGuard moduleKey={actionsKeys.INCIDENT_MANAGEMENT} action={action}>
      {children}
    </PermissionGuard>
  );
};

export const IncidentMgmtRoutes = () =>  {
  return {
    path: routes.incidentMgmt,
    children: [
      {
        path: "",
        element: <IncidentMgmtGuard><OwnerIncidentMgmt /></IncidentMgmtGuard>,
      },
      {
        path: routes.add,
        element: <IncidentMgmtGuard action={routes.add}><OwnerAddEditIncident /></IncidentMgmtGuard>,
      },
      {
        path: `${routes.id}/${routes.action}`,
        element: <IncidentMgmtGuard><OwnerAddEditIncident /></IncidentMgmtGuard>,
      },
    ]
  }
};
